<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><img alt="" src="OEBPS/images/Flyn_9780765340351_epub_001_r1.png"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780765340351_epub_map_r1.vue?4d4282b4